const base_url = "https://cactusfrance.com/api/pro"
export const public_url = "https://cactusfrance.com/public/uploads/";

export const login_url = base_url + "/prof/profSignIn";
export const profile_url = base_url + "/prof/getProfile";
export const getCodesCountUrl = base_url + "/getCodesCount";
export const getCodesUrl = base_url + "/getActivationCodes";
export const getModulesExportOptionsUrl = base_url + "/getDistinctModuleExportOptions";
export const ExportPDFUrl = base_url + "/exportCodesToPDF";
export const getActivationLinksUrl = base_url + "/getActivationLinks";
export const sendActivationCodesEmailUrl = base_url + "/sendActivationCodesEmail";


export const getProfsUrl = base_url + "/getProfList";
export const addProfUrl = base_url + "/addProf"
export const assignCodesToProfUrl = base_url + "/assignCodesToProf";
export const suspendProfUrl = base_url + "/suspendProf";
export const getSingleProfUrl = base_url + "/getSingleProf";
export const updateProfUrl = base_url + "/updateProf";
export const reclaimAllProfsCodesUrl = base_url + "/reclaimAllProfsCodes";
export const reclaimSingleProfCodesUrl = base_url + "/reclaimSingleProfCodes";
export const getNumberOfReclaimableCodesUrl = base_url + "/getProfReclaimableCodes";
export const getNamedProfListUrl = base_url + "/searchProfByName";


// Activation codes
export const reclaimAllCodesUrl = base_url + "/reclaimAllCodes";

// Classes routes
export const fetchClassroomsUrl = base_url + "/prof/getClassListProf";
export const getClassByIdUrl = base_url + "/prof/getClassById";
export const generateSinglePupilUrl = base_url + "/prof/generateSinglePupil";
export const generatePupilsXlsxUrl = base_url + "/prof/generatePupilsFromXLSX";
export const addClassroomUrl = base_url + "/class/createClassRoom";
export const addProflessClassroomUrl = base_url + "/class/createProflessClassRoom";
export const modifyClassroomUrl = base_url + "/class/modifyClassroom";
export const uploadXLSXUrl = base_url + "/prof/upload/uploadXLSXFile";
export const fetchLessonSelectionUrl = base_url + "/prof/getModulesForSession"
export const startSessionUrl = base_url + "/prof/startSession"
export const stopSessionUrl = base_url + "/prof/stopSession"
export const pollSessionUrl = base_url + "/prof/getSessionUpdate"
export const removeUserFromSessionUrl = base_url + "/prof/removePupilFromSession"
export const getSingleExerciseDataUrl = base_url + "/prof/getSingleExerciseData"
export const getSessionListUrl = base_url + "/prof/getSessionList"
export const getSingleSessionUrl = base_url + "/prof/getSingleSession"
export const removePupilFromClassUrl = base_url + "/prof/removePupilFromClass"